import { objectHasKeys } from '@/utils/comparators'

const getAllUserActivity = (state) => {
  let activities = objectHasKeys(state.userActivityItems) ? Object.values(state.userActivityItems) : []
  let sorted = activities.sort((a, b) => { return b.timestamp > a.timestamp ? 1 : -1 })
  return sorted
}

const getLatestSequenceNumber = (state) => {
  return state.latestSequenceNumber
}

const isEndOfTail = (state) => {
  return state.isEndOfTail
}

export default {
  getAllUserActivity,
  getLatestSequenceNumber,
  isEndOfTail
}



// WEBPACK FOOTER //
// ./src/store/modules/user/activity/getters.js